/**
 * useProjectHasArchitecture — whether the project has at least one architecture diagram.
 *
 * Mirrors useProjectHasTasks. Drives conditional rendering of the
 * "Review the design and architecture and start building" action bar so we
 * fall back to a Continue button when architecture (or tasks) haven't been
 * generated yet — the message only carries Build/Export buttons once both
 * are actually ready.
 */
import { useRtkLoadingSignal } from '../components/PlanningWorkspaceGate/useRtkLoadingSignal';
import {
  hasArchitecture,
  useGetArchitectureQuery,
} from '../store/services/architectureApi';

export function useProjectHasArchitecture(projectId: string | null | undefined): boolean {
  const query = useGetArchitectureQuery(projectId ?? '', { skip: !projectId });

  // Action bars swap Continue ↔ Build once this lands; hold the loading shell meanwhile.
  useRtkLoadingSignal('architecture', query);

  return hasArchitecture(query.currentData);
}
